import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=044abccc"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports